import type { SearchFilter, SearchScope } from "./search-types.js";

export type CitationCoverage = "direct" | "partial" | "context";
export type ClaimSupportStatus = "supported" | "partially_supported" | "insufficient_evidence";
export type GroundedAnswerMode = "qa" | "compare" | "topic";

export type Citation = {
  sourceId: string;
  sourceTitle: string;
  sectionId?: string;
  sectionPath?: string[];
  pageStart?: number;
  pageEnd?: number;
  chunkIds: string[];
  snippet: string;
  coverage: CitationCoverage;
  confidence: number;
};

export type ClaimEvidenceMap = {
  claimId: string;
  claimText: string;
  status: ClaimSupportStatus;
  citations: Citation[];
  missingEvidenceReasons?: string[];
};

export type GroundedAnswer = {
  answer: string;
  claims: ClaimEvidenceMap[];
  citations: Citation[];
  warnings: string[];
  grounded: boolean;
};

export type GroundingBudget = {
  maxVerifyLoops: number;
  maxResearchQueriesPerLoop: number;
  maxCitationsPerClaim: number;
  maxClaimsPerAnswer: number;
};

export const DEFAULT_GROUNDING_BUDGET: GroundingBudget = {
  maxVerifyLoops: 2,
  maxResearchQueriesPerLoop: 3,
  maxCitationsPerClaim: 3,
  maxClaimsPerAnswer: 12,
};

export type GroundedClaimInput = {
  claimId?: string;
  claimText: string;
  requiredTerms?: string[];
};

export type GroundedCompareInput = {
  left: string;
  right: string;
};

export type GroundedTopicInput = {
  minDistinctSections?: number;
};

export type GroundedAnswerInput = {
  question: string;
  scope: SearchScope;
  filters?: SearchFilter;
  claims?: GroundedClaimInput[];
  mode?: GroundedAnswerMode;
  compare?: GroundedCompareInput;
  topic?: GroundedTopicInput;
  budget?: Partial<GroundingBudget>;
};

export type GroundingRuntime = {
  answer(input: GroundedAnswerInput): Promise<GroundedAnswer>;
};
